<template>
  <div
    class="use-cases-image"
    v-if="imagesProps">
    <pict
      class="use-cases-image__image"
      block-name="use-cases-image"
      :default="imagesProps.default"
      :sources="imagesProps.sources" />
  </div>
</template>

<script>
import imageL from "./images/image_en.png";
import imageL2x from "./images/image_en@2x.png";
import imageLDE from "./images/image_de.png";
import imageL2xDE from "./images/image_de@2x.png";

import imageTabletL from "./images/image_tablet_en.png";
import imageTabletL2x from "./images/image_tablet_en@2x.png";
import imageTabletLDE from "./images/image_tablet_de.png";
import imageTabletL2xDE from "./images/image_tablet_de@2x.png";

import Pict from "@/shared/pict";

import getLocale from "@/utils/locale";

export default {
  name: "UsecasesImage",
  components: {
    Pict
  },
  computed: {
    imagesProps() {
      if (getLocale() === "de") {
        return {
          default: {
            src: imageLDE,
            srcset: {
              "2x": imageL2xDE
            }
          },
          sources: [
            {
              media: "xs",
              src: imageLDE,
              srcset: {
                "2x": imageL2xDE
              }

            },
            {
              media: "m",
              src: imageTabletLDE,
              srcset: {
                "2x": imageTabletL2xDE
              }
            }
          ]
        };
      }
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "xs",
            src: imageL,
            srcset: {
              "2x": imageL2x
            }

          },
          {
            media: "m",
            src: imageTabletL,
            srcset: {
              "2x": imageTabletL2x
            }
          }
        ]
      };
    }
  }

};
</script>

<style lang="scss" scoped>
.use-cases-image {
  position: relative;

  display: inline-block;

  &__audio-container {
    position: absolute;

    display: flex;

    align-items: center;

    height: 100%;
  }

  ::v-deep &__image { // stylelint-disable-line
    z-index: 1;

    width: 100%;
  }
}
</style>
